import script from "./WhyChooseUs.vue?vue&type=script&setup=true&lang=js"
export * from "./WhyChooseUs.vue?vue&type=script&setup=true&lang=js"

import "./WhyChooseUs.vue?vue&type=style&index=0&id=25a511ef&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25a511ef"]])

export default __exports__